import { AlertCircle, CheckCircle2, Info } from 'lucide-react';
import type { ReactNode } from 'react';
import { ApiError } from '../api/envelope';

type Tone = 'danger' | 'warn' | 'ok' | 'info';

const TONE_CLASS: Record<Tone, string> = {
  danger: 'note note-danger',
  warn: 'note note-warn',
  ok: 'note note-ok',
  info: 'note',
};

/**
 * Inline message panel. 1001/1003 server messages are user-facing and shown
 * verbatim — that's the contract (provider probe errors arrive this way).
 */
export function Note({ tone = 'info', children }: { tone?: Tone; children: ReactNode }) {
  const Icon = tone === 'ok' ? CheckCircle2 : tone === 'info' ? Info : AlertCircle;
  return (
    <div className={TONE_CLASS[tone]} role={tone === 'danger' ? 'alert' : undefined}>
      <Icon size={15} />
      <div>{children}</div>
    </div>
  );
}

export function ErrorNote({ error }: { error: ApiError | Error | string }) {
  const message =
    typeof error === 'string' ? error : error.message || 'Something went wrong.';
  return <Note tone="danger">{message}</Note>;
}
